import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWORK } from "../../../../common/constants/appRoad"
import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"

import { roadworksQueryKeys } from "./queryKeys"

export function useYearsStatsQuery(
    config = {},
) {
    const { selectedNetwork } = useNetworksStateContext()
    const url = "roadworks/stats/years/"
    const parameters = useExtendWithSubnetworks({
        project: selectedNetwork,
    }, API_MODULE_ROADWORK, "sub_networks")
    const queryKey = roadworksQueryKeys["years_stats"](parameters)

    return useRoadworksQuery(
        url,
        queryKey,
        parameters,
        config,
    )
}
